<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/intelligent/scheduling/details/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, beforeGet)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="clear()">{{ $t('chongzhi') }} </el-button>
          </el-form-item>


        </el-form>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
export default {
  name: 'equimpentIssue',
  data() {
    return {
      allIds: [],
      checkDisabled: false,
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'jihuadanhao',
          prop: 'plan.no',
          width: 180
        },
        {
          label: 'ERPgongdanhao',
          prop: 'plan.erpNo',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 130
        },
        {
          label: 'jihuashuliang',
          prop: 'quantity',
          width: 130
        },
        {
          label: 'jiaoqi',
          prop: 'deliveryPeriodDate',
          type: 'time',
          width: 180
        },

        {
          label: 'paichengmingxizhuangtai',
          prop: 'status',
          width: 130,
          type: 'tag',
          tags: {
            1: { color: '#F56C6C', text: this.$t('UNISSUED') },
            2: {
              color: '#67C23A',
              text: this.$t('GRANT')
            },
            3: { color: '#dc362e', text: this.$t('PENDING') }
          }
        },
        {
          label: 'jihuakaishishijian',
          prop: 'planStartTime',
          type: 'time',
          width: 180
        },
        {
          label: 'jihuawanchengshijian',
          prop: 'planEndTime',
          type: 'time',
          width: 180
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.orderBy = 'planStartTime asc';
      this.yt.conditions.status = '1';
      this.yt.conditions.pageSize = 999;
      this.yt.get(1, this.beforeGet);
      this.yt.isShowPagination = false;
    }, 300);
  },
  methods: {
    beforeGet(params) {
      if (!(params.equipmentIdList.length > 0)) {
        this.yt.list = []
        return false;
      }
      return params;
    },
    clear() {
      this.yt.conditions.equipmentIdList = [];
      this.yt.conditions.orderBy = 'planStartTime asc';
      this.yt.conditions.status = '1';
      this.yt.conditions.pageSize = 999;
      this.yt.list = []
      this.yt.isShowPagination = false;
    },
    selectionChange(items) {
      this.allIds = items.map(item => {
        return item.id;
      });
      if (this.allIds.length > 0) {
        this.checkDisabled = false;
      } else {
        this.checkDisabled = true;
      }
    }
  }
};
</script>

<style scoped></style>
